
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { v4 as uuidv4 } from 'uuid'; // Add UUID import

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Export the UUID function from the uuid package
export { uuidv4 }

/**
 * Formats backend/database field names and values for user-friendly display
 * Converts underscores and dashes to spaces and applies proper capitalization
 * @param text - The text to format (e.g., "project_type", "in_progress")
 * @returns Formatted text (e.g., "Project Type", "In Progress")
 */
export function formatDisplayText(text: string): string {
  if (!text || typeof text !== 'string') return text;

  return text
    .replace(/[_-]/g, ' ')           // Replace underscores and dashes with spaces
    .replace(/\b\w/g, l => l.toUpperCase()) // Capitalize first letter of each word
    .trim();                         // Remove any extra whitespace
}
